import React, { useEffect, useState } from "react";

import "./Branches.css";

import Container from "../Container";

import Branch from "./Branch";



const Branches = () => {

  const [activeFlyer, setActiveFlyer] = useState(null);

  useEffect(() => {

    if (!activeFlyer) return undefined;

    const handleEscape = (event) => {

      if (event.key === "Escape") setActiveFlyer(null);

    };

    const previousOverflow = document.body.style.overflow;

    document.body.style.overflow = "hidden";

    document.addEventListener("keydown", handleEscape);

    return () => {

      document.body.style.overflow = previousOverflow;

      document.removeEventListener("keydown", handleEscape);

    };

  }, [activeFlyer]);

  return (

    <Container>

      <section className="branches">

        <div className="branches-title">

          <div className="b-title">Sucursales</div>

          <div className="b-description">

            SUCURSALES A SU DISPOSICIÓN EN TODO EL PAÍS

          </div>

        </div>

        <div className="branches-items">

          <Branch

            location="Centro de Diagnóstico"

            descriptions={[

              "75 metros al norte de la terminal de buses Tracopa"

            ]}

            mapsLink="https://maps.app.goo.gl/L2ssHqjUNb2zoyQ67?g_st=aw"

            wazeLink="https://waze.com/ul/hd1u0qz0e3"

            image="/assets/Address15.jpeg"

            onImageClick={setActiveFlyer}

          />

          <Branch

            location="Cartago Centro"

            descriptions={[

              "Frente a los Bomberos de Costa Rica"

            ]}

            mapsLink="https://maps.app.goo.gl/QxG6w35DVovikBFr9"

            wazeLink="https://waze.com/ul/hd1u247bwu"

            image="/assets/Address11.jpeg"

            onImageClick={setActiveFlyer}

          />

          <Branch

            location="Alajuela"

            descriptions={[

              "75 metros Sur los semáforos de la Corte"

            ]}

            mapsLink="https://maps.app.goo.gl/v1q4DhYCeS4hbzJe7"

            wazeLink="https://waze.com/ul/hd1u158h25"

            image="/assets/Address13.jpeg"

            onImageClick={setActiveFlyer}

          />

          <Branch

            location="Guadalupe"

            descriptions={[

              "75 metros Este de la Musmanni"

            ]}

            mapsLink="https://maps.app.goo.gl/r8gcMThBcjQm311G7"

            wazeLink="https://waze.com/ul/hd1u0x6d40"

            image="/assets/Address12.jpeg"

            onImageClick={setActiveFlyer}

          />

          <Branch

            location="San Ramón"

            descriptions={[

              "50 metros al Este de Tiendas Ekono"

            ]}

            mapsLink="https://maps.app.goo.gl/6sqne8zctDrXMHvE7?g_st=ipc"

            wazeLink=""

            image="/assets/Address3.jpeg"

            onImageClick={setActiveFlyer}

          />

          <Branch

            location="El Roble, Puntarenas"

            descriptions={[

              "Frente al Banco de Costa Rica"

            ]}

            mapsLink="https://maps.app.goo.gl/rzcFaFjigTdmzKaeA"

            wazeLink="https://waze.com/ul/hd1g8zbdrz"

            image="/assets/Address2.jpeg"

            onImageClick={setActiveFlyer}

          />

          <Branch

            location="Cañas"

            descriptions={[

              "Frente al Banco Nacional"

            ]}

            mapsLink="https://maps.app.goo.gl/YGJwaYcvYuo9p1MZ8"

            wazeLink="https://ul.waze.com/ul?place=ChIJUQLdDRb7n48RJt_Ih61KNrk&ll=10.42695560%2C-85.09126830&navigate=yes&utm_campaign=default&utm_source=waze_website&utm_medium=lm_share_location"

            image="/assets/Address6.jpeg"

            onImageClick={setActiveFlyer}

          />

          <Branch

            location="Tres Ríos"

            descriptions={[

              "50 metros Este del Mas x Menos, Edificio Sabino Guzmán frente a Plaza Estación"

            ]}

            mapsLink="https://maps.app.goo.gl/snxLcuiVD6LjVmMaA"

            wazeLink="https://waze.com/ul/hd1u22gc9y"

            image="/assets/Address9.jpeg"

            onImageClick={setActiveFlyer}

          />

          <Branch

            location="Liberia"

            descriptions={[

              "75 metros Oeste de Correos de Costa Rica, frente a Ferretería San Carlos"

            ]}

            mapsLink="https://maps.app.goo.gl/8Ea1KMaSgdMzcMbe9"

            wazeLink=""

            image="/assets/Address4.jpeg"

            onImageClick={setActiveFlyer}

          />

          <Branch

            location="Heredia"

            descriptions={[

              "Banco Popular del Liceo, 75 metros al Este"

            ]}

            mapsLink="https://maps.app.goo.gl/A4py8Zf1Aew1T22i9"

            wazeLink="https://waze.com/ul/hd1u0vujwn"

            image="/assets/Address14.jpeg"

            onImageClick={setActiveFlyer}

          />

          <Branch

            location="Sucursal Barrio Dent: Los Yoses"

            descriptions={[

              "300 al norte de Ambacar, Centro médico Bonanza"

            ]}

            mapsLink="https://www.google.com/maps/search/Clinica+Studio+Visual+Barrio+Dent+Los+Yoses+Costa+Rica"

            wazeLink="https://www.waze.com/search?q=Clinica%20Studio%20Visual%20Barrio%20Dent%20Los%20Yoses"

            image="/assets/Address18.jpeg"

            onImageClick={setActiveFlyer}

          />

          <Branch

            location="Guápiles"

            descriptions={[

              "Plaza Comercial Guápiles, contiguo a Subway"

            ]}

            mapsLink="https://maps.app.goo.gl/4WNDe1Z3Dx2zVi978"

            wazeLink="https://ul.waze.com/ul?preview_venue_id=181010534.1810170878.19879810&navigate=yes&utm_campaign=default&utm_source=waze_website&utm_medium=lm_share_location"

            image="/assets/Address8.jpeg"

            onImageClick={setActiveFlyer}

          />

          <Branch

            location="Nicoya"

            descriptions={[

              "300 metros Norte de Hospital La Anexión, diagonal a Ekono, frente al Colono Agropecuario"

            ]}

            mapsLink="https://maps.app.goo.gl/QH7YaXtykoSpyifc9"

            wazeLink="https://waze.com/ul/hd1g1z80rd"

            image="/assets/Address5.jpeg"

            onImageClick={setActiveFlyer}

          />

          <Branch

            location="San Carlos"

            descriptions={[

              "Barrio San Roque, frente a la Iglesia Católica"

            ]}

            mapsLink="https://maps.app.goo.gl/ywGTNXK9CswKmeSv6"

            wazeLink="https://waze.com/ul/hd1gfy8qc2"

            image="/assets/Address7.jpeg"

            onImageClick={setActiveFlyer}

          />

          <Branch

            location="San José Av8"

            descriptions={[

              "Del Diario Extra 200 metros al Sur y 25 metros Este sobre Av8"

            ]}

            mapsLink="https://maps.app.goo.gl/CS7ctqsouabyYnkN8"

            wazeLink="https://ul.waze.com/ul?place=ChIJo6qagl3joI8Rdgv6XSvqYeE"

            image="/assets/Address16.jpeg"

            onImageClick={setActiveFlyer}

          />

          <Branch

            location="Escazú"

            descriptions={[

              "100 metros Norte del parque, contiguo a POPS"

            ]}

            mapsLink="https://www.google.com/maps/search/Clinica+Studio+Visual+Escazu+Costa+Rica"

            wazeLink="https://waze.com/ul/hd1u0mq47r"

            image="/assets/Address1.jpeg"

            onImageClick={setActiveFlyer}

          />

          <Branch

            location="Grecia"

            descriptions={[

              "Costado del parque, contiguo a Taquería Los Pira"

            ]}

            mapsLink="https://www.google.com/maps/search/Clinica+Studio+Visual+Grecia+Costa+Rica"

            wazeLink=""

            image="/assets/Address17.jpeg"

            onImageClick={setActiveFlyer}

          />

          <Branch

            location="Pérez Zeledón"

            descriptions={[

              "50 oeste de La Casa de la Juventud, esquina Clínica San Lucas diagonal al parqueo de Pali"

            ]}

            mapsLink="https://maps.app.goo.gl/ugq6WM3yviR2mhWM7"

            wazeLink="https://waze.com/ul/hd1smr3ber"

            image="/assets/Address10.jpeg"

            onImageClick={setActiveFlyer}

          />

        </div>

        <div className="schedule">

          Lunes a Sábado: 9:00 am a 6:00 pm | Paseo de las Flores: abierto domingos de 10:00 am a 8:00 pm

        </div>

        {activeFlyer && (

          <div className="branch-flyer-overlay" onClick={() => setActiveFlyer(null)} role="presentation">

            <div

              aria-label={`Flyer de la sucursal ${activeFlyer.location}`}

              aria-modal="true"

              className="branch-flyer-modal"

              onClick={(event) => event.stopPropagation()}

              role="dialog"

            >

              <button

                aria-label="Cerrar flyer"

                className="branch-flyer-close"

                onClick={() => setActiveFlyer(null)}

                type="button"

              >

                ×

              </button>

              <img alt={`Sucursal ${activeFlyer.location}`} className="branch-flyer-image" src={activeFlyer.image} />

            </div>

          </div>

        )}

      </section>

    </Container>

  );

};



export default Branches;


